<script lang="ts">
  import { onMount } from 'svelte'
  import { getData } from './parseRawData'
  import { columns } from './tableCols'
  import SvelteTable from 'svelte-table'
  import type { SheetRow } from './types/SheetRow'

  let data = getData()
  let urlMonth = new URLSearchParams(window.location.search).get('month')

  let open = false
</script>

<main class="main-content">
  <a href="http://lem.ink/api/test">TEST API</a>
  <br />
  {#await data}
    ..loading..
  {:then dataJsonArray}
    <SvelteTable rows={dataJsonArray} {columns} iconDesc={'⬇'} iconAsc={'⬆'} />
  {/await}
</main>

<style>
  main {
    text-align: center;
    padding: 1em;
    margin: 0 auto;
  }
</style>
